import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { ForStudentComponent } from './for-student/for-student.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {path:'list',component:ListComponent,canActivate: [PermissionGuard],
    data: { roles: ['admin', 'Managment', 'Sales', 'HR', 'Training Moderator', 'Teacher'] }
  },
  {path:'current-list',component:ListComponent,canActivate: [PermissionGuard],
    data: { roles: ['admin', 'Managment', 'Sales', 'HR', 'Training Moderator', 'Teacher'] }
  },
  {path:'future-list',component:ListComponent,canActivate: [PermissionGuard],
    data: { roles: ['admin', 'Managment', 'Sales', 'HR', 'Training Moderator', 'Teacher'] }
  },
  {path:'past-list',component:ListComponent,canActivate: [PermissionGuard],
    data: { roles: ['admin', 'Managment', 'Sales', 'HR', 'Training Moderator', 'Teacher'] }
  },
  
  {path:'',component:ForStudentComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventsRoutingModule { }
